import { generalServiceV1API } from '@/store/api-instance'
import { AxiosResponse } from 'axios'
import { IGetDeliveryAvailableDateRequest } from '@/store/modules/deliveryDates/interfaces/IGetAvailableDateRequest'
import { TransportationTypes } from '@/utils/transportTypes'

export default async function getDeliveryAvailableDateAPI (queryParams: IGetDeliveryAvailableDateRequest) {
  const query = { ...queryParams }
  switch (queryParams.shipmentId) {
    case TransportationTypes.POSM:
      query.deliveryDateType = 'POSM'
      break
    case TransportationTypes.UNFILTERED:
      query.deliveryDateType = 'Unfiltered'
      break
    case TransportationTypes.TANK:
      query.deliveryDateType = 'Tank'
      break
    default:
      query.deliveryDateType = 'Standard'
      break
  }
  const response: AxiosResponse = await generalServiceV1API.get('orders/GetDeliveryAvailableDate', { params: query })
  return response.data
}
